module.exports = __webpack_public_path__ + "static/media/logo_1.5203bd2f.png";